import request, { requestBaseUrl } from '@/utils/request'

// ========================项目维度=====================================
// 项目主页界面
// api/project/iconStatistics 项目卡片接口
export function getSummaryData(data, config = {}) {
  const options = {
    url: 'api/dash/project/iconStatistics',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}

// api/project/home  获取项目列表，项目主页
export function getProjectHomeList(data, config = {}) {
  const options = {
    url: 'api/dash/project/home',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}


// api/project/home  获取项目列表，项目主页
export function getProjectHomeList1(data, config = {}) {
  const options = {
    url: 'api/dash/project/homeTable',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}

//项目详情界面
// api/project/contract 项目卡片接口
export function getContractListFromProject(data, config = {}) {
  const options = {
    url: 'api/dash/project/contractDee',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}

//项目下穿
// api/project/contract 项目卡片接口
export function getTasksListFromProject(data, config = {}) {
  const options = {
    url: 'api/dash/project/task',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}

// api/project/order 项目卡片接口
export function getOrdersListFromProject(data, config = {}) {
  const options = {
    url: 'api/dash/project/order',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}

//项目下穿生产详情界面
// dash_api/task/production 通过任务单获取生产详情接口
export function getProductionInfFromProject(data, config = {}) {
  const options = {
    url: 'api/dash/project/production',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}

//项目下穿生产详情界面
// dash_api/task/production 通过任务单获取生产详情接口
export function getDesignInfFromProject(data, config = {}) {
  const options = {
    url: 'api/dash/project/design',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}
// ========================项目维度=====================================




// ========================合同维度=====================================
// 合同主页界面
// api/project/home  获取合同列表，合同主页
// export function getContractHomeList(data, config = {}) {
//   const options = {
//     url: 'api/dash/contract/home',
//     method: 'post',  // 改为 POST 方法
//     data: data       // 使用 data 而不是 params
//   };
  
//   // 如果有其他配置，合并进来
//   Object.assign(options, config);
  
//   return request(options)
// }

// api/project/home  获取合同列表，合同主页
export function getContractHomeList(data, config = {}) {
  const options = {
    url: 'api/dash/contract/contractDee',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}

//合同详情界面
// api/contract/task 合同详情页面订单列表的任务单号子列表接口
export function getTasksListFromContract(data, config = {}) {
  const options = {
    url: 'api/dash/contract/task',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}


// api/contract/bom 合同详情页面订单列表的bom子列表接口
export function getBomsListFromContract(data, config = {}) {
  const options = {
    url: 'api/dash/contract/bom',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}

//合同详情界面
// api/contract/order 合同详情页面订单列表接口
export function getOrdersListFromContract(data, config = {}) {
  const options = {
    url: 'api/dash/contract/order',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}


//合同维度问题详情列表
// api/dash/contract/getIssueList  入参 { contractNo }，返回 data.list（问题明细）
export function getContractIssueList(data, config = {}) {
  const options = {
    url: 'api/dash/contract/getIssueList',
    method: 'post',
    data: data
  };

  // 如果有其他配置，合并进来
  Object.assign(options, config);

  return request(options)
}

//合同下穿生产详情界面
// dash_api/task/production 通过任务单获取生产详情接口
export function getProductionInfFromContract(data, config = {}) {
  const options = {
    url: 'api/dash/contract/production',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}

//合同下穿生产详情界面
// dash_api/task/production 通过任务单获取生产详情接口
export function getDesignInfFromContract(data, config = {}) {
  const options = {
    url: 'api/dash/contract/design',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}


// api/main 接口
export function getReviewStatus(data){
  return request({
    url: 'api/dash/utils/getReviewStatus',
    method: 'GET',
    params: data
  })
}
// ========================合同维度=====================================



// ========================任务单维度=====================================
// 任务单主页界面
// api/dash/task/home  获取任务单列表，任务单主页
export function getWorkOrderHomeList(data, config = {}) {
  const options = {
    url: 'api/dash/task/home',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}


//任务单生产详情界面
// dash_api/task/production 通过任务单获取生产详情接口
export function getProductionInfFromTask(data, config = {}) {
  const options = {
    url: 'api/dash/task/production',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}

//任务单设计详情界面
// dash_api/task/design 通过任务单获取设计详情接口
export function getDesignInfFromTask(data, config = {}) {
  const options = {
    url: 'api/dash/task/design',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}
// ========================任务单维度=====================================

// ========================产品维度=====================================
// // 产品主页界面
// // api/dash/products  获取产品列表，产品主页老接口，带有参数赋值
// export function getProductHomeList(data, config = {}) {
//   // POST 请求，Type/Page/PageSize 走 params，Body 走 data
//   const params = {
//     Type: String(data.Type),
//     Page: String(data.Page),
//     PageSize: String(data.PageSize)
//   };
  
//   const options = {
//     url: 'api/dash/products',
//     method: 'post',
//     params: params,
//     data: data.Body
//   };
  
//   // 如果有其他配置，合并进来
//   Object.assign(options, config);
  
//   return request(options)
// }


// 产品主页界面
// api/dash/products  获取产品列表，产品主页老接口，带有参数赋值
export function getProductHomeList(data, config = {}) {
  const options = {
    url: 'api/dash/products',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };

  // 如果有其他配置，合并进来
  Object.assign(options, config);

  return request(options)
}


// 产品问题列表（产品主页「问题列表」入口）
// api/dash/products/getIssueList  入参见下方页面注释，返回 data.list / data.total
export function getProductIssueList(data, config = {}) {
  const options = {
    url: 'api/dash/products/issueList',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };

  // 如果有其他配置，合并进来
  Object.assign(options, config);

  return request(options)
}

// ========================产品维度=====================================

// ========================部件维度=====================================
// 部件主页界面
// api/dash/parts/home  获取产品列表，产品主页
// 任务单主页界面
// api/dash/task/home  获取任务单列表，任务单主页
export function getPartHomeList(data, config = {}) {
  const options = {
    url: 'api/dash/parts/home',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}
// ========================部件维度=====================================

// ========================异常信息维度=====================================
// 异常信息界面
// api/dash/user/abnormal  获取异常列表，或者某天异常
export function getAbnormalList(data, config = {}) {
  const options = {
    url: 'api/dash/user/abnormal',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}

// api/dash/user/exceptionInfo  获取具体某条对应异常
export function getAbnormalInfo(data, config = {}) {
  const options = {
    url: 'api/dash/exceptionInfo',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}

// api/dash/user/abnormal  获取异常列表的某个日期范围的异常
export function getAbnormalDateList(data, config = {}) {
  const options = {
    url: 'api/dash/calendar',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}
// ========================异常信息维度=====================================


// ========================售后信息维度=====================================
// 售后信息界面
// api/dash/afterSales/project  获取项目下所有售后信息
export function getAfterSaleInfoFromProject(data, config = {}) {
  const options = {
    url: 'api/dash/afterSales/project',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}

// // api/dash/afterSales/project  获取合同下所有售后信息
// export function getAfterSaleInfoFromContract(data, config = {}) {
//   const options = {
//     url: 'api/dash/afterSales/contract',
//     method: 'post',  // 改为 POST 方法
//     data: data       // 使用 data 而不是 params
//   };
  
//   // 如果有其他配置，合并进来
//   Object.assign(options, config);
  
//   return request(options)
// }


// api/dash/afterSales/contract  获取合同下所有售后编号
export function getAfterSaleNoFromContract(data, config = {}) {
  const options = {
    url: 'api/dash/afterSales/contract',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}


// api/dash/afterSales/details  获取合同下所有售后编号
export function getAfterSaleInfoFromNo(data, config = {}) {
  const options = {
    url: 'api/dash/afterSales/details',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}

// ========================售后信息维度=====================================


// ========================驾驶舱卡片维度=====================================
// 项目列表（合同，任务号）编辑更新数据
export function getDashboardCardData(data, config = {}) {
  const options = {
    url: 'api/dash/cockpit',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}
// ========================驾驶舱卡片维度=====================================


// ========================用户信息维度=====================================
// 用户信息设置界面
// api/user/management  获取用户设置界面的管理员表格
export function getManagementList(data, config = {}) {
  const options = {
    url: 'api/dash/user/management',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}

// api/user/management  修改用户设置界面的管理员权限
export function setManagementList(data, config = {}) {
  const options = {
    url: 'api/dash/user/management',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}

// api/user/updatePermission 修改用户权限
export function updateUserPermission(data, config = {}) {
  const options = {
    url: 'api/dash/user/updatePermission',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}

// api/user/ResetPassword  清空用户密码
export function clearUserPassword(data, config = {}) {
  const options = {
    url: 'api/dash/user/ResetPassword',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}

// api/user/ResetPassword  注销用户信息
export function cancelUserAccount(data, config = {}) {
  const options = {
    url: 'api/dash/user/DeactivateAccount',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config);
  
  return request(options)
}
// ========================用户信息维度=====================================





// ========================编辑接口维度=====================================
// 项目列表（合同，任务号）编辑更新数据
export function UpdateDataList(data){
  return request({
      url: 'api/dash/utils/update',
    method: 'POST',
    params: data
  })
}

// 产品列表编辑更新数据（Type: ProductDetail 单条/批量备注更新；\）
export function UpdateProductsDataList(data, Type = 'ProductDetail'){
  return request({
      url: 'api/dash/utils/updateProductsDetail',
    method: 'POST',
    params: { Type: Type },
    data: data
  })
}

// 产品列表编辑更新数据（Type: ProductDetail 单条/批量备注更新；Type: Import 批量导入 CSV 解析）
export function BatchImportRemark(data, config = {}){
  const options = {
    url: 'api/dash/products/batchImportRemark',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}

// 确认批量导入的按钮
export function BatchImportConfirm(data, config = {}){
  const options = {
    url: 'api/dash/products/batchImportConfirm',
    method: 'post',  // 改为 POST 方法
    data: data       // 使用 data 而不是 params
  };
  
  // 如果有其他配置，合并进来
  Object.assign(options, config); 
  return request(options)
}

// 列偏好：保存
export function UpdateProgressConfig(data){
  return request({
      url: 'api/updateProgressConfig',
      method: 'POST',
      data: data
  })
}

// ========================编辑接口维度=====================================




// ========================工位管理维度=====================================
// 工位管理：获取工位列表（GET）
//   params.processCode: 可选，'A' / 'B' / ... 按区筛选，空字符串或不传 = 全部
//   后端返回 data 数组，每项字段（下划线命名）：
//     station_id     工位编号，如 B.02.01.03
//     station_name   工位名称        station_remark 备注
//     process_code   所属区          station_status 工位状态（待机 / 运行 …）
//     station_type   工位类型        operator       负责人
//     row_no / col_no / pos_no      行号 / 列号 / 位号
//     group          后端已不使用，前端直接忽略
//   编号规则：`{processCode}.{rowNo:02}.{colNo:02}.{posNo:02}`，如 A.01.01.01
export function getStationList(params = {}, config = {}) {
  const options = {
    url: 'api/dash/cockpit/station',
    method: 'get',
    params: params
  };

  // 如果有其他配置，合并进来
  Object.assign(options, config);

  return request(options)
}

/* ==================== 工位信息 SSE 实时推送 ====================
   接口：GET api/dash/cockpit/station/sse
   鉴权：API Key → Query params 里的 token（EventSource 不能带请求头，所以只能拼在 URL 上）
   入参：processCode = 'A'（区号，默认取实参）
   行为：后端每 5 秒推一条本区最新工位信息（字段与 getStationList 的 data 数组一致）
   说明：SSE 是服务端单向长推流，axios 会做缓冲、拿不到增量数据，
        所以这里不用 request，直接返回 EventSource；调用方负责 .close() 关流
   @param {Object} params  { processCode }
   @param {Object} handlers { onOpen, onMessage, onError } 事件回调（可选，也可外面自己 .onmessage = …）
   @returns {EventSource}
*/
export function getStationListSse(params = {}, handlers = {}) {
  const qs = new URLSearchParams();
  qs.set('processCode', params.processCode || '');
  // 登录 token 存在 localStorage 的 'token' 里（与 request 拦截器用的同一个）
  qs.set('token', window.localStorage.getItem('token') || '');

  const es = new EventSource(`${requestBaseUrl}api/dash/cockpit/station/sse?${qs.toString()}`);
  if (handlers.onOpen) es.onopen = handlers.onOpen;
  if (handlers.onMessage) es.onmessage = handlers.onMessage;
  if (handlers.onError) es.onerror = handlers.onError;
  return es;
}

// 工位管理：保存/更新工位列表（POST）
//   params.Type = 'WorkStationSave'
//   data = { stations: [...] }，每个 station 字段：
//          processCode, rowNo, colNo, posNo, order, name, group,
//          type, operator, status, remark；新增行可省略 id，由后端分配
//   返回：{ code, message, data: [ { result: 'success' } ... ] }
export function saveStationList(data, Type = 'WorkStationSave', config = {}) {
  const options = {
    url: 'api/dash/cockpit/station',
    method: 'post',
    params: { Type: Type },
    data: data
  };

  // 如果有其他配置，合并进来
  Object.assign(options, config);

  return request(options)
}
// ========================工位管理维度=====================================







// api/main 接口
export function apiMain(data){
  return request({
    url: 'api/main',
    method: 'GET',
    params: data
  })
}
// api/main 分页接口
export function apiMainMultiple(data){
  return request({
    url: 'api/main/multiple',
    method: 'GET',
    params: data
  })
}
// 获取合同列表
export function getDataList1(data){
  return request({
      url: 'api/main',
    method: 'GET',
    params: data
  })
}


// 获取合同列表
export function getDataList(data){
  return request({
      url: 'api/main/multiple',
    method: 'GET',
    params: data
  })
}




// 这个是老的
export function getContractIdList(data){
  return request({
    url: 'api/main',
    method: 'GET',
    params: data
  })
}

// TODO:FAN获取合同号列表,这个是新的
export function getProductInfoList(data){
  return request({
    url: 'api/products',
    method: 'GET',
    params: data
  })
}

// 获取跟进信息
export function getProjectFollow(data){
  return request({
    url: 'api/projectFollow',
    method: 'GET',
    params: data
  })
}

// 获取RSA公钥接口 - 根据后端接口名称修正
export function getPublicKey() {
  return request({
    url: 'api/getPublicKey', // 根据您的后端接口路径
    method: 'GET'
  })
}


// 用户登录
export function userLogin(data){
  return request({
    url: 'api/login',
    method: 'POST',
    data: data
  })
}

// 用户注册
export function userRegister(data){
  return request({
    url: 'api/register',
    method: 'POST',
    data: data
  })
}

// 用户登出
export function logout(data){
  return request({
    url: 'api/logout',
    method: 'GET',
    data: data
  })
}
// 首页消息
export function homgPageMessage(){
  return request({
    url: 'api/autoCreate',
    method: 'GET',
  })
}